import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=ba0618c0&scoped=true&"
import script from "./categories.vue?vue&type=script&lang=babel&"
export * from "./categories.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0618c0",
  null
  
)

export default component.exports